import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../core/services/config.service';
import { fuseAnimations } from '../../../core/animations';
import { UsuariosService } from '../usuarios/usuarios.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';

@Component({
    selector   : 'fuse-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls  : ['./forgot-password.component.scss'],
    animations : fuseAnimations
})
export class FuseForgotPasswordComponent implements OnInit
{
    forgotPasswordForm: FormGroup;
    forgotPasswordFormErrors: any;

    desabilitarBoton = false;

    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private usuariosService: UsuariosService,
        private notificaciones: NotificacionesService
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });

        this.forgotPasswordFormErrors = {
            email: {}
        };
    }

    ngOnInit()
    {
        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.forgotPasswordForm.valueChanges.subscribe(() => {
            this.onForgotPasswordFormValuesChanged();
        });
    }

    onForgotPasswordFormValuesChanged()
    {
        for ( const field in this.forgotPasswordFormErrors )
        {
            if ( !this.forgotPasswordFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.forgotPasswordFormErrors[field] = {};

            // Get the control
            const control = this.forgotPasswordForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.forgotPasswordFormErrors[field] = control.errors;
            }
        }
    }

    onSubmit() {
        this.desabilitarBoton = true;
        const email = this.forgotPasswordForm.value.email;
        this.usuariosService.forgotPassword(email).subscribe(
            data => {
                if (data.success) {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.PassReseteada);
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.PassNoReseteada);
                }
            },
            err => {
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido);
                this.desabilitarBoton = false;
            }
        );

      }
}



// WEBPACK FOOTER //
// ./src/app/main/content/forgot-password/forgot-password.component.ts